import { render, staticRenderFns } from "./ResumenCargador.vue?vue&type=template&id=0e50a84c&"
import script from "./ResumenCargador.vue?vue&type=script&lang=js&"
export * from "./ResumenCargador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports